import { isNil } from 'lodash-es';

/**
 *
 * @param {*} raw
 * @return {ctTokenModel.type}
 */
export const ctTokenModel = (raw) => ({
  ctToken: raw.ctToken || '',
  refreshToken: raw.refreshToken || '',
});

/** @typedef  {{ctToken: string, refreshToken: string}} */
ctTokenModel.type = '';

export const ctTokenPayloadModelDefault = {
  iss: '',
  aud: '',
  iat: 0,
  exp: 0,
  website_id: -1,
  user_id: -1,
  email: '',
  full_name: '',
  admin: false,
  permissions: [],
  start_channel_id: null,
  start_channel_slug: null,
  uploadedVideosCount: 0,
};

/**
 * @param {*} raw
 * @return {{iss: string, aud: string, iat: number, exp: number, website_id: number, user_id: number, email: string, full_name: string, permissions: array}}
 */
export const ctTokenPayloadModel = (raw) => {
  if (!raw) {
    return ctTokenPayloadModelDefault;
  }

  return {
    iss: raw.iss || ctTokenPayloadModelDefault.iss,
    aud: raw.aud || ctTokenPayloadModelDefault.aud,
    iat: !isNil(raw.iat) ? raw.iat : ctTokenPayloadModelDefault.iat,
    exp: !isNil(raw.exp) ? raw.exp : ctTokenPayloadModelDefault.exp,
    website_id: !isNil(raw.website_id) ? raw.website_id : ctTokenPayloadModelDefault.website_id,
    user_id: !isNil(raw.user_id) ? raw.user_id : ctTokenPayloadModelDefault.user_id,
    email: raw.email || ctTokenPayloadModelDefault.email,
    full_name: raw.full_name || ctTokenPayloadModelDefault.full_name,
    admin: raw.admin || ctTokenPayloadModelDefault.admin,
    permissions: raw.permissions || ctTokenPayloadModelDefault.permissions,
    start_channel_id: raw.start_channel_id || ctTokenPayloadModelDefault.start_channel_id,
    start_channel_slug: raw.start_channel_slug || ctTokenPayloadModelDefault.start_channel_slug,
    uploadedVideosCount: raw.uploadedVideosCount || ctTokenPayloadModelDefault.uploadedVideosCount,
  };
};
